import { render, staticRenderFns } from "./abbuchen.vue?vue&type=template&id=1555a542&scoped=true&"
import script from "./abbuchen.vue?vue&type=script&lang=js&"
export * from "./abbuchen.vue?vue&type=script&lang=js&"
import style0 from "./abbuchen.vue?vue&type=style&index=0&id=1555a542&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1555a542",
  null
  
)

export default component.exports